import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";

const input = "w-full rounded-xl border border-[#27272A] bg-[#09090B] px-4 py-2.5 text-base text-[#FAF9F6] outline-none focus:border-[#D4AF37]";

export function UserEditDialog({ user, onClose, onChanged }) {
  const [f, setF] = useState({ name: "", email: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const [confirmDel, setConfirmDel] = useState(false);

  useEffect(() => {
    if (user) setF({ name: user.name || "", email: user.email, phone: user.phone || "" });
    setConfirmDel(false);
  }, [user]);

  const run = async (fn, ok) => {
    setBusy(true);
    try {
      await fn();
      toast.success(ok);
      onChanged();
    } catch (e) {
      toast.error(apiError(e?.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const save = (e) => { e.preventDefault(); run(() => api.put(`/admin/users/${user.id}`, f), "Dati salvati"); };
  const toggleFree = (enabled) => run(() => api.put(`/admin/users/${user.id}/free-access`, { enabled }), enabled ? "Accesso gratuito attivato" : "Accesso rimosso");
  const del = () => run(() => api.delete(`/admin/users/${user.id}`), "Iscritto cancellato");
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  return (
    <Dialog open={!!user} onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="max-w-[400px] border-[#27272A] bg-[#121215] text-[#FAF9F6]" data-testid="admin-user-dialog">
        <DialogHeader><DialogTitle className="font-serif-el text-2xl">Modifica iscritto</DialogTitle></DialogHeader>
        {user && (
          <>
            <form onSubmit={save} className="space-y-2.5">
              <label className="block text-sm text-[#A1A1AA]">Nome<input required value={f.name} onChange={set("name")} data-testid="admin-user-name" className={`${input} mt-1`} /></label>
              <label className="block text-sm text-[#A1A1AA]">Email<input required type="email" value={f.email} onChange={set("email")} data-testid="admin-user-email" className={`${input} mt-1`} /></label>
              <label className="block text-sm text-[#A1A1AA]">Telefono<input value={f.phone} onChange={set("phone")} data-testid="admin-user-phone" className={`${input} mt-1`} /></label>
              <button type="submit" disabled={busy} data-testid="admin-user-save" className="btn-gold flex w-full items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm uppercase tracking-wide">
                {busy && <Loader2 size={15} className="animate-spin" />} Salva dati
              </button>
            </form>

            <div className="mt-2 flex items-center justify-between rounded-xl border border-[#27272A] p-3.5">
              <div>
                <p className="font-semibold">Accesso gratuito</p>
                <p className="text-[13px] text-[#8A8E96]">{user.free_access ? "Attivo, senza pagamento" : user.subscription_active ? "Ha un abbonamento attivo" : "Percorso bloccato"}</p>
              </div>
              <Switch checked={user.free_access} disabled={busy || user.role === "admin"} onCheckedChange={toggleFree} data-testid="admin-user-free-toggle" />
            </div>

            {user.role !== "admin" && (
              !confirmDel ? (
                <button onClick={() => setConfirmDel(true)} data-testid="admin-user-delete" className="mt-1 inline-flex items-center gap-2 text-sm text-[#FCA5A5] hover:text-[#F87171]">
                  <Trash2 size={15} /> Cancella iscritto
                </button>
              ) : (
                <div className="mt-1 rounded-xl border border-[#F87171]/40 bg-[#F87171]/8 p-3.5">
                  <p className="text-sm text-[#FECACA]">Cancellare per sempre {user.email}? Si perdono account, percorso e messaggi. L'eventuale abbonamento viene annullato.</p>
                  <div className="mt-3 flex gap-2">
                    <button onClick={del} disabled={busy} data-testid="admin-user-delete-confirm" className="flex-1 rounded-full bg-[#DC2626] px-4 py-2 text-sm font-semibold text-white">Sì, cancella</button>
                    <button onClick={() => setConfirmDel(false)} data-testid="admin-user-delete-cancel" className="flex-1 rounded-full border border-[#27272A] px-4 py-2 text-sm">Annulla</button>
                  </div>
                </div>
              )
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
